module.exports = __webpack_public_path__ + "GOTHIC.cfce6abbbff0099b1569.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GOTHIC.ttf
// module id = 687
// module chunks = 3